export const environment = {
    production: true,
    apiUrl: "https://num.fma.org.ma",
};
